








import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class SearchResultEmpty extends Vue {
  @Prop()
  private text!: string;
}
